import { type SxProps, type Theme } from '@mui/material'

const headCell = {
  textTransform: 'uppercase',
  fontSize: '0.7rem',
  fontWeight: 700,
  color: 'text.secondary',
  letterSpacing: '0.04em',
  borderBottom: '1px solid',
  borderColor: 'divider'
}

export const styles = {
  scroller: {
    overflowX: 'auto'
  } satisfies SxProps<Theme>,
  headCell: headCell satisfies SxProps<Theme>,
  sortableHeadCell: {
    ...headCell,
    cursor: 'pointer',
    userSelect: 'none'
  } satisfies SxProps<Theme>
}
